import React from "react";
import { Link } from "react-router-dom";
import { Layout, Image } from "antd";
import "./header.css";
import { useGetIsDesktop } from "extensions";
import { useCompany } from "@redux";

const icon = require("@assets/sport_logo.png");
const { Header: HeaderComp } = Layout;

const Header = () => {
  const company = useCompany();
  const isDesktop = useGetIsDesktop();
  const headerMain = (
    <div className="header-main">
      <div className="header-title">{company && company.name}</div>
      <div className="header-prompt">{company && company.address}</div>
    </div>
  )

  const headerLogo = (<div className="header-logo"><Link to="/home"><div className="header-image-container"><Image width={185} height={96} src={company?.pictureFileName ? (process.env.REACT_APP_API_BASE_URL + "/api/image/" + company.pictureFileName) : icon}  preview={false} /></div></Link></div>)
    return (
        <>
      {isDesktop && (
        <HeaderComp className="header">
                    {headerLogo}
                    {headerMain}
        </HeaderComp>
      )}
            <div>
        {isDesktop || headerLogo}
        {isDesktop || headerMain}
            </div>
        </>
    );
};

export default Header;
